import React from 'react';
import { PublicLayout } from '../components/layout/Layout';
import { RegisterForm } from '../components/auth/RegisterForm';

const Register = ({ errors }) => {
  return (
    <PublicLayout>
      <RegisterForm errors={errors} />
    </PublicLayout>
  );
};

export default Register;
